/* eslint-disable import/no-anonymous-default-export */
export default [
    {
        title_cn: '2023华乐演奏会',
        title_en: '2023 Chinese Music Grading Concert',
        time: '17/DEC 2.30-4.30pm',
        address: 'YW MUSIC 艺伟琴行',
        phone: '',
        image: 'https://ywmusic-resource.s3.ap-southeast-2.amazonaws.com/activities/chinese_music_concert.jpg',
        Facebook: 'https://www.facebook.com/echoofjademusiccollective',
        Instagram: 'https://www.instagram.com/echoofjademusiccollective?fbclid=IwAR2sVhRspv9xXjwOe119YgcDEGWin0EGgdzdCLqwmNb5PxUkFDD2b4XmIRY',
        Youtube: 'https://www.youtube.com/@EchoofJadeMusicCollective',

    },
    {
        title_cn: '琵琶 课程体验',
        title_en: 'Pipi Trial Class Regist Now',
        time: '22th JUL 2023 Sat',
        address: '3/233 Calam Road, Sunnybank Hills 4109',
        phone: '07 32726668',
        image: 'https://ywmusic-resource.s3.ap-southeast-2.amazonaws.com/activities/pipa_trail_calss.jpg',
        Facebook: 'https://www.facebook.com/echoofjademusiccollective',
        Instagram: 'https://www.instagram.com/echoofjademusiccollective?fbclid=IwAR2sVhRspv9xXjwOe119YgcDEGWin0EGgdzdCLqwmNb5PxUkFDD2b4XmIRY',
        Youtube: 'https://www.youtube.com/@EchoofJadeMusicCollective',
    },
    {
        title_cn: '古筝 课程体验',
        title_en: 'Guzheng Trial Class Regist Now',
        time: '6th AUG 2023 SUN, 9AM - 1PM',
        address: '3/233 Calam Road, Sunnybank Hills 4109',
        phone: '07 32726668',
        image: 'https://ywmusic-resource.s3.ap-southeast-2.amazonaws.com/activities/guzheng_trail_calss.jpg',
        Facebook: 'https://www.facebook.com/echoofjademusiccollective',
        Instagram: 'https://www.instagram.com/echoofjademusiccollective?fbclid=IwAR2sVhRspv9xXjwOe119YgcDEGWin0EGgdzdCLqwmNb5PxUkFDD2b4XmIRY',
        Youtube: 'https://www.youtube.com/@EchoofJadeMusicCollective',
    },
    {
        category: 'Upcoming Events',
        title_cn: '等级考试',
        title_en: 'Chinese Traditional Music Grading Examination',
        time: '20/08/2023 15:00-17:00',
        address: 'Shop 3/223 Calam Road , Sunnybank Hills 4109',
        announcement: `
            「Event Schedule:」
            Central Conservatory of Music Overseas Chinese Traditional Music Grading Examination Preparatory Mock Test for August 2023
            YW MUSIC Chinese Traditional Music Student Mid-Year Presentation for 2023
            Professional Evaluation by Examiners from the China Conservatory of Music
            Demonstrative Performance by YW MUSIC's Chinese Traditional Music Professional Instructors
            「Target Audience:」
            YW MUSIC Chinese Traditional Music students, whether or not taking the examination
            Individuals with a passion for Chinese music 、Chinese instruments and an interest in learning about it
            「Admission」
            YW MUSIC students can attend for free
            Non-YW MUSIC students need to pay a registration fee of $50 (Sharing this poster on WeChat Moments, Little Red Book, INS/Facebook, or any other social platform and receiving a minimum of 10 likes qualifies for free admission)
            For registration, please scan the QR code on WeChat or contact us by phone for inquiries.
        `,
        image: 'https://ywmusic-resource.s3.ap-southeast-2.amazonaws.com/activities/Music_Grading_Examination.jpg',
        Facebook: 'https://www.facebook.com/echoofjademusiccollective',
        Instagram: 'https://www.instagram.com/echoofjademusiccollective?fbclid=IwAR2sVhRspv9xXjwOe119YgcDEGWin0EGgdzdCLqwmNb5PxUkFDD2b4XmIRY',
        Youtube: 'https://www.youtube.com/@EchoofJadeMusicCollective',
    },
]